export default function Vision() {
  return;
}